import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getAccessToken } from '../configuration/tokenHandling/tokenSlice';
import { getUserAccount } from '../configuration/login/loginSlice';

// IDs de contas autorizadas a usar o botão de token (carregado da environment)
const ALLOWED_ACCOUNTS = import.meta.env.VITE_TOKEN_BUTTON_ALLOWED_ACCOUNTS
  ? import.meta.env.VITE_TOKEN_BUTTON_ALLOWED_ACCOUNTS.split(',').map((id: string) => id.trim())
  : [];

export const useCopyToken = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const accessToken = useSelector(getAccessToken);
  const userAccount = useSelector(getUserAccount);

  const copyToken = async () => {
    try {
      if (!accessToken || accessToken === 'NO_ACCESS_TOKEN_AVAILABLE') {
        setShowError(true);
        setTimeout(() => setShowError(false), 3000);
        return;
      }

      // Verifica se é o token mock
      if (accessToken === 'valid-mocked-oauth-bogus-token') {
        setShowError(true);
        setTimeout(() => setShowError(false), 3000);
        return;
      }

      await navigator.clipboard.writeText(accessToken);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch (error) {
      console.error('Erro ao copiar token:', error);
      setShowError(true);
      setTimeout(() => setShowError(false), 3000);
    }
  };

  const isAccountAllowed = userAccount && ALLOWED_ACCOUNTS.includes(userAccount);

  return {
    copyToken,
    showSuccess,
    showError,
    accessToken,
    isAccountAllowed,
  };
};
